import moment from 'moment-timezone';

const EXPIRY_TZ = 'America/New_York';

/** Same formula as the DTE column: trading days left including expiry day. */
export function getDisplayDte(expireAt) {
    if (!expireAt) return null;
    return moment.tz(expireAt, EXPIRY_TZ).diff(moment().tz(EXPIRY_TZ), 'days') + 1;
}

export function getDaysToExpiry(expireAt) {
    const dte = getDisplayDte(expireAt);
    if (dte === null) return null;
    return dte - 1;
}

/** CSS class for Exp/DTE cells — must use !important to override .table color rules. */
export function getExpiryClassName(expireAt) {
    const dte = getDisplayDte(expireAt);
    if (dte === null) return '';
    if (dte <= 0) return 'option-exp-expired';
    if (dte <= 2) return 'option-exp-soon';
    return '';
}

export function getExpiryColor(expireAt) {
    const className = getExpiryClassName(expireAt);
    if (className === 'option-exp-expired') return '#f87171';
    if (className === 'option-exp-soon') return '#fbbf24';
    return undefined;
}
